import React, { useState, useEffect } from 'react'
import axios from 'axios'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faSearch, faPrint, faKey } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import ImpresionCierre from '../cierresdecaja/ImpresionCierre'
import VentasDiscriminadas from './VentasDiscriminadas'
import Cookies from 'universal-cookie'
import TableroInforme from './TableroInforme'
import BusquedaFechas from '../pedidos/BusquedaFechas'
import ReactToPrint from 'react-to-print'
import { useRef } from 'react'
import { jsonrepair } from 'jsonrepair'

const InformesAdmin = ({ baseUrl, Titulo, baseMediosdePago, baseUsuarios, config, usuario, baseCierres, roll }) => {

	//aqui se ingresan todos los pagos hechos con un medio de pago, queda un listado
	//de tamaño pedidos:
	const [data, setData] = useState([]);
	const [dataCierres, setDataCierres] = useState([])
	const [consecutivo, setConsecutivo] = useState(0)
	const [cierre, setCierre] = useState({})
	const [productosEncon, setProductosEncon] = useState([])
	const [productoFull, setProductoFull] = useState([])
	const [load, setLoad] = useState(false)

	const [mediosdePagoRecar, setMediosdePagoRecar] = useState([])
	const [mediosdePagoRecarFull, setMediosdePagoRecarFull] = useState([])
	const [usuariosEncon, setUsuariosEncon] = useState([])
	const [usuariosFull, setUsuariosFull] = useState([])
	const [resultados, SetResultados] = useState({
		pedidosAct: 0, pedidoCredito: 0, ventasTotal: 0, valorDescPersona: 0
	})
	const [descuentosPersonalizados, setDescuentosPersonalizados] = useState([])
	const [descPersoFull, setDescPersoFull] = useState([])
	const [funcion, setFuncion] = useState('ver')

	const [startDate, setStartDate] = useState(new Date());
	const [finalFecha, setFinalFecha] = useState(new Date());

	const [mediosdePago, setMediosdePago] = useState([])
	const [usuarios, setUsuarios] = useState([])
	const [btnAvanzado, setBtnAvanzado] = useState(false)
	const [resultCierre, setResultCierre] = useState(false)
	const [btnsCierre, setBtnsCierre] = useState(true)
	const ventasImprimir = useRef()

	const [filtroTipoPedido, setFiltroTipoPedido] = useState('Todos')

	const fecha = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
	const cookies = new Cookies()
	//const myDate = moment(str, 'YYYY-MM-DD').toDate();

	const CierreZ = e => {
		setFuncion('cierreZ')
		setResultCierre(false)
		setBtnsCierre(true)
		SubeparaCierre('X', 'completo')
	}

	const CierreX = e => {
		setFuncion('cierreX')
		setResultCierre(false)
		setBtnsCierre(true)
		SubeparaCierre('X', 'completo')

	}

	const CierreDefinitivo = (tipo, modo) => e => {

		if (tipo === 'X') {
			if (modo === 'completo') { SubeparaCierre('X', 'completo') }
			else { SubeparaCierre('X', 'parcial') }
		}
		if (tipo === 'Z') {
			SubeparaCierre('Z', 'completo')
		}


		//revisa cual es el id mayor
		let respuesta = 0
		dataCierres.map(item => {
			let id = parseFloat(item.id)
			if (id > respuesta) {
				respuesta = id
			}
		})

		setConsecutivo(respuesta + 1)

		peticionPost(tipo);

		setBtnsCierre(false)

	}



	const SubeparaCierre = (tipo, modo) => {

		let obj = {
			tipo: tipo,
			modo: modo,
			usuario: usuario,
			config: config,
			fecha: fecha,
	
			ventasBrutas: resultados.ventasTotal,
			pedidosActivos: resultados.pedidosAct + resultados.pedidoCredito,
			totalPedidosActivos: resultados.valorPedidosActivos,
	
			descPersonali: resultados.descPersona,
			totalDescPersonali: resultados.valorDescPersona,
	
			pedidosCredito: resultados.pedidoCredito,
			totalPedidosCredito: resultados.valorCreditos,
	
			pedidosCancel: resultados.pedidoCancel,
			totalPedidosCancel: resultados.valorPedidoCancel,
	
			descPer: descPersoFull,
			ventasProduct: productoFull,
			ventasUsuarios: usuariosFull,
			ventasMedios: mediosdePagoRecarFull

		}
		setCierre(obj)
		
	}


	const agregaResultado = e => {

		const result = {
			ventasTotal: 0,
			valorPedidosActivos: 0,
			pedidosAct: 0,
			valorPedidoCancel: 0,
			pedidoCancel: 0,
			pedidoCredito: 0,
			valorCreditos: 0,
			descPersona: 0,
			valorDescPersona: 0,
			totalFee: 0,
			taxes: 0
		}

		let Medioo = []
		let Users = []
		let Productos = []
		let DescuentosPer = []

		data.map((item) => {
			let hoy = moment(startDate).format("DD-MM-YYYY")

			let fecha = item.fecha
			let fechaFormat = moment(fecha).format("DD-MM-YYYY")
			let momentA = moment(hoy, "DD/MM/YYYY");
			let momentB = moment(fechaFormat, "DD/MM/YYYY");


			if (momentA > momentB) {
				//console.log('mayor')
			}
			else if (momentA < momentB) {
				//console.log('menor')
			}
			else {

				if (item.estado === 'Aprobado') {	
					//incluye creditos
					result.ventasTotal = parseFloat(item.datosPago.total) + result.ventasTotal

					if (item.datosPago.estadoMedio === 'contado') {
						//solo si son contados
						result.pedidosAct++
						result.valorPedidosActivos = parseFloat(item.datosPago.total) + result.valorPedidosActivos

					} else {
						//aca sería los creditos
						result.pedidoCredito++
						result.valorCreditos = parseFloat(item.datosPago.total) + result.valorCreditos
					}

					//calcula Fee
					if (item.datosPago.totalFee){result.totalFee = parseFloat(item.datosPago.totalFee) + result.totalFee}

					//calcula Taxes
					result.taxes = parseFloat(item.datosPago.taxes) + result.taxes

					if (parseFloat(item.datosPago.valorDescPersonali) > 0) {
						result.descPersona++
					}
					result.valorDescPersona = parseFloat(item.datosPago.valorDescPersonali || 0) + result.valorDescPersona

					DescuentosPer.push({
						cantidad: 1,
						total: parseFloat(item.datosPago.valorDescPersonali),
						nombre: item.datosPago.nombreDescPersonali
					})


					//sube todos los medios de pago que encuentre y les pone el total
					// quedando listo para luego sumar los iguales

					Users.push({
						cantidad: 1,
						nombre: item.datosPago.vendedor,
						total: item.datosPago.total
					})

					// SI tiene medios de pago de los nuevos hace este proceso
					//console.log('item.datosPago.mediosPagoPasarela 2', item.datosPago.mediosPagoPasarela)
					if (item.datosPago.mediosPagoPasarela){
						//console.log('aca 1', item.datosPago.mediosPagoPasarela)

						mediosdePago.map((it) => {
							item.datosPago.mediosPagoPasarela.map((md) => {
								if (md.medioPagoNombre === it.nombre) {
									Medioo.push({
										cantidad: 1,
										nombre: md.medioPagoNombre,
										tarifaPorcentaje: md.tarifaPorcentaje,
										interes: md.interes,
										cambio: item.datosPago.cambio,
										totalfac: item.datosPago.total,
										total: md.medioPagoNombre === 'Efectivo' ? md.importe < 1 || item.datosPago.total < 1 ? 0 : md.importe - parseFloat(item.datosPago.cambio) 
										: md.importe + md.tarifaPorcentaje + md.interes
											//md.importe 
									})
								}
							})
						})
					//proceso de medios de pago antiguos
					}else{
						mediosdePago.map((it) => {
						if (item.datosPago.medio === it.nombre) {
							Medioo.push({
								cantidad: 1,
								nombre: item.datosPago.medio,
								total: item.datosPago.total
							})
							}
						})
					}

					//proceso de medios SI ES CON APP:
					if (item.datosPago.canal === 'App' && item.estado === 'Aprobado') {
						Medioo.push({cantidad: 1, nombre: 'App', total: parseFloat(item.datosPago.total)})
					}
					
					//proceso de medios SI ES PÁGINA:
					if (item.datosPago.canal === "Tienda" && item.estado === 'Aprobado') {
						Medioo.push({cantidad: 1, nombre: 'Página web', total: parseFloat(item.datosPago.total)})
					}



					item.pedido.map((itemm) => {
						Productos.push({
							nombre: itemm.nombre_producto,
							precio: parseFloat(itemm.precio_rebajado) > 0 ? parseFloat(itemm.precio_rebajado) : parseFloat(itemm.precio_producto),
							cantidad: itemm?.cantidad_producto ? itemm.cantidad_producto : itemm.cantidad ,
							total: itemm?.total_pedido ? parseFloat(itemm.total_pedido) : (itemm?.precio_rebajado && parseFloat(itemm?.precio_rebajado > 0) ? parseFloat(itemm?.precio_rebajado) : parseFloat(itemm?.precio_producto))
						})
					})


				} else {
					//aca los pedidos cancelados
					result.pedidoCancel++
					result.valorPedidoCancel = parseFloat(item.datosPago.total) + result.valorPedidoCancel
				}
			}
		})
		SetResultados(result)
		setMediosdePagoRecar(Medioo)
		setUsuariosEncon(Users)
		setProductosEncon(Productos)
		setDescuentosPersonalizados(DescuentosPer)

	}

	const peticionTraeDatosAvanza = () => {

		setLoad(true)
		const result = { ventasTotal: 0, valorPedidosActivos: 0, pedidosAct: 0, valorPedidoCancel: 0, pedidoCancel: 0, pedidoCredito: 0, valorCreditos: 0, descPersona: 0, valorDescPersona: 0, totalFee: 0, taxes: 0}

		let Medioo = []
		let Users = []
		let Productos = []
		let DescuentosPer = []

		let inicioFechaFormat = moment(startDate).format("YYYY-MM-DD")
		let finalFechaFormat = moment(finalFecha).format("YYYY-MM-DD")

		axios.get(baseUrl, { params: { tipo: 'avanzada', date: inicioFechaFormat, date2: finalFechaFormat } })
			.then(response => {
				let respuesta = response.data
				let newArr = []
				FormatearConsulta(respuesta, newArr)

				newArr.map((item => {
					if (item.estado === 'Aprobado') {
						//incluye creditos
						result.ventasTotal = parseFloat(item.datosPago.total) + result.ventasTotal

						if (item.datosPago.estadoMedio === 'contado') {
							//solo si son contados
							result.pedidosAct++
							result.valorPedidosActivos = parseFloat(item.datosPago.total) + result.valorPedidosActivos
						} else {
							//aca sería los creditos
							result.pedidoCredito++
							result.valorCreditos = parseFloat(item.datosPago.total) + result.valorCreditos
						}

						if (parseFloat(item.datosPago.valorDescPersonali) > 0) {
							result.descPersona++
						}

						//calcula Fee
						if (item.datosPago.totalFee){result.totalFee = parseFloat(item.datosPago.totalFee) + result.totalFee}

						//calcula Taxes
						result.taxes = parseFloat(item.datosPago.taxes) + result.taxes

						result.valorDescPersona = parseFloat(item.datosPago.valorDescPersonali || 0) + result.valorDescPersona

						DescuentosPer.push({
							cantidad: 1,
							total: parseFloat(item.datosPago.valorDescPersonali || 0),
							nombre: item.datosPago.nombreDescPersonali
						})

						//sube todos los medios de pago que encuentre y les pone el total
						// quedando listo para luego sumar los iguales

						Users.push({
							cantidad: 1,
							nombre: item.datosPago.vendedor,
							total: parseFloat(item.datosPago.total)
						})

						// SI tiene medios de pago de los nuevos hace este proceso
					if (item.datosPago.mediosPagoPasarela){
						mediosdePago.map((it) => {
							item.datosPago.mediosPagoPasarela.map((md) => {
								if (md.medioPagoNombre === it.nombre) {
									Medioo.push({
										cantidad: 1,
										nombre: md.medioPagoNombre,
										total: md.medioPagoNombre === 'Efectivo' ? md.importe < 1 || item.datosPago.total < 1 ? 0 : md.importe - parseFloat(item.datosPago.cambio) :
											md.importe + md.tarifaPorcentaje + md.interes
											//md.importe 
									})
								}
							})
						})

					//proceso de medios de pago antiguos
					}else{
						mediosdePago.map((it) => {
						if (item.datosPago.medio === it.nombre) {
							Medioo.push({
								cantidad: 1,
								nombre: item.datosPago.medio,
								total: item.datosPago.total
							})
							}
						})
					}

					//proceso de medios SI ES CON APP:
					if (item.datosPago.canal === 'App' && item.estado === 'Aprobado') {
						Medioo.push({cantidad: 1, nombre: 'App', total: parseFloat(item.datosPago.total)})
					}
					
					//proceso de medios SI ES PÁGINA:
					if (item.datosPago.canal === "Tienda" && item.estado === 'Aprobado') {
						Medioo.push({cantidad: 1, nombre: 'Página web', total: parseFloat(item.datosPago.total)})
					}


					item.pedido.map((itemm) => {
						Productos.push({
							nombre: itemm.nombre_producto,
							precio: parseFloat(itemm.precio_rebajado) > 0 ? parseFloat(itemm.precio_rebajado) : parseFloat(itemm.precio_producto),
							cantidad: itemm?.cantidad_producto ? itemm.cantidad_producto : itemm.cantidad ,
							total: itemm?.total_pedido ? parseFloat(itemm.total_pedido) : (itemm?.precio_rebajado && parseFloat(itemm?.precio_rebajado > 0) ? parseFloat(itemm?.precio_rebajado) : parseFloat(itemm?.precio_producto))
						})
					})


					} else {
						//aca los pedidos cancelados
						result.pedidoCancel++
						result.valorPedidoCancel = parseFloat(item.datosPago.total) + result.valorPedidoCancel
					}
				}))

				SetResultados(result)
				setMediosdePagoRecar(Medioo)
				setUsuariosEncon(Users)
				setProductosEncon(Productos)
				setDescuentosPersonalizados(DescuentosPer)
				setLoad(false)
			})
			.catch(error => {
				console.log(error)

			})
	}
	useEffect(() => {

		agregaResultado()

	}, [data, mediosdePago, usuarios])

	useEffect(() => {
		agregaResultado()
	}, [startDate, filtroTipoPedido])

	useEffect(() => {
		//busquedaAvanzada()
		peticionTraeDatosAvanza()
	}, [startDate, finalFecha, filtroTipoPedido])


	const FormatearConsulta = (respuesta, newArr) => {
		respuesta.map((item) => {
			if (filtroTipoPedido == "Todos") {
				newArr.push({
					...item,
					fecha: moment(item.fecha, 'YYYY-MM-DD HH-mm-ss:').toDate(),
					datosPago: item.datosPago !== "" ? JSON.parse(jsonrepair(item.datosPago)) : '',
					pedido: item.pedido !== "" ? JSON.parse(jsonrepair(item.pedido)) : '',
					cliente: item.cliente !== "" ? JSON.parse(jsonrepair(item.cliente)) : ''
				})
			}

			if ((JSON.parse(item.datosPago).canal ? JSON.parse(item.datosPago).canal : 'App') == filtroTipoPedido) {
				newArr.push({
					...item,
					fecha: moment(item.fecha, 'YYYY-MM-DD HH-mm-ss:').toDate(),
					datosPago: item.datosPago !== "" ? JSON.parse(item.datosPago) : '',
					pedido: item.pedido !== "" ? JSON.parse(item.pedido) : '',
					cliente: item.cliente !== "" ? JSON.parse(item.cliente) : ''
				})
			}


		})

	}

	const peticionTraeDatos = () => {
		let inicioFechaFormat = moment(startDate).format("YYYY-MM-DD")
		axios.get(baseUrl, { params: { tipo: 'simple', date: inicioFechaFormat } })
			.then(response => {
				let respuesta = response.data
				let newArr = []
				FormatearConsulta(respuesta, newArr)
				setData(newArr)
			})
			.catch(error => {
				console.log(error)
			})
	}

	const peticionTraeMedios = () => {
		axios.get(baseMediosdePago)
			.then(response => {
				let respuesta = response.data
				respuesta.push({ nombre: 'Efectivo', total: 0 })
				setMediosdePago(respuesta)
			})

	}

	const peticionTraeUsuarios = () => {

		axios.get(baseUsuarios, { params: { id: '14', usuario: '1', clave: '1', unico: 'false' } })
			.then(response => {
				setUsuarios(response.data)
			}).catch(error => { console.log(error) })
	}

	const peticionTraeCierres = () => {

		axios.get(baseCierres)
			.then(response => {
				let respuesta = response.data
				setDataCierres(respuesta)

			}).catch(error => {
				console.log(error)
			})
	}

	//Trae todas las mediodePagos de la api
	useEffect(() => {
		peticionTraeDatos()
		peticionTraeMedios()
		peticionTraeUsuarios()
		peticionTraeCierres()
	}, [])


	// calcula, suma, elimina: -----------------------------------------------

	useEffect(() => {
		CalculaDiscriminados(productosEncon, setProductoFull)
	}, [productosEncon])


	useEffect(() => {
		CalculaDiscriminados(descuentosPersonalizados, setDescPersoFull)
	}, [descuentosPersonalizados])


	useEffect(() => {
		CalculaDiscriminados(usuariosEncon, setUsuariosFull)
	}, [usuariosEncon])


	useEffect(() => {
		CalculaDiscriminados(mediosdePagoRecar, setMediosdePagoRecarFull)
	}, [mediosdePagoRecar])


	const CuentaIguales = (nombre, objeto) => {
		let respuesta = 0
		objeto.map(item => {
			if (item.nombre === nombre) respuesta = item.cantidad + respuesta
		})
		return respuesta
	}

	const CalculaTotales = (nombre, objeto) => {
		let respuesta = 0
		objeto.map(item => {
			if (item.nombre === nombre) respuesta = parseFloat(item.total) + respuesta
		})
		return respuesta
	}

	const CalculaDiscriminados = (objetoInicial, seteador) => {

		let NewArr = []
		objetoInicial.map((item) => {
			NewArr.push({
				nombre: item.nombre,
				valor: parseFloat(item.total),
				cantidad: CuentaIguales(item.nombre, objetoInicial),
				total: CalculaTotales(item.nombre, objetoInicial)
			})
		})

		//eliminar repetidos
		let newArrayFull = NewArr.map(e => e['nombre'])
			// store the keys of the unique objects
			.map((e, i, final) => final.indexOf(e) === i && i)
			// eliminate the dead keys & store unique objects
			.filter(e => NewArr[e]).map(e => NewArr[e]);

		newArrayFull.sort(function (a, b) {
			return b.cantidad - a.cantidad;
		});
		seteador(newArrayFull)
	}

	//Consulta para subir o crear los datos 
	const peticionPost = (tipo) => {
		let fechaNueva = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

		//console.log('tipo',tipo)
		let f = new FormData()
		f.append('fecha', fechaNueva)
		f.append('tipo', tipo)
		f.append('usuario', usuario)
		f.append('datos', JSON.stringify({ pedidos: cierre.pedidosActivos, total: cierre.ventasBrutas }))
		f.append('METHOD', 'POST')
		axios.post(baseCierres, f)

			.then(response => {
				let respuesta = response.data
				setDataCierres([...dataCierres, response.data])
				setResultCierre(true)
			}).catch(error => {
				console.log(error);
			})

	}

	// camponente de fecha: -----------------------------------------------

	const ExampleCustomInput = ({ value, onClick, nombre }) => (
		<button className="btn boton_estandar" onClick={onClick}>
			<FontAwesomeIcon icon={faCalendarAlt} size="1x" /> {nombre}: {value}
		</button>
	)
	//

	return (
		<div>

			<div className="row">
				<div className="col-md-6">
					<br />
					<h2>{Titulo}:</h2>
				</div>
				<div className="col-md-6">
					<div className="filtroPedidos">
						<button
							onClick={CierreZ}
							className="btn boton_estandar btn-lg gigante derecha">
							<FontAwesomeIcon icon={faKey} /> Cierre Z
						</button>
						<button
							onClick={CierreX}
							className="btn boton_estandar btn-lg gigante derecha">
							<FontAwesomeIcon icon={faPrint} /> Cierre X
						</button>
					</div>
				</div>
			</div>

			{funcion === 'ver' && roll === 'Admin' ?
				<div>
					<hr />
					<div className="row">
						<div className="col-md-8 SinPadding d-flex">
							{!btnAvanzado ?
								<DatePicker
									dateFormat="dd/MM/yyyy"
									selected={new Date(startDate)}
									onChange={date => setStartDate(date)}
									customInput={<ExampleCustomInput nombre='Fecha Simple' />}
								/>
								: null}

							<button
								onClick={e => setBtnAvanzado(!btnAvanzado)}
								className="btn boton_estandar_blanco"
							><FontAwesomeIcon icon={faSearch} size="lg" />
							</button>

							{btnAvanzado ?
								<BusquedaFechas
									startDate={startDate}
									setStartDate={setStartDate}
									finalFecha={finalFecha}
									setFinalFecha={setFinalFecha}
									left={true}
								/>
								: null}

						</div>
						<div className='col-md-4'>
							<select
								style={{ width: '50px !important' }}
								className="browser-default custom-select selectAtri"
								value={filtroTipoPedido}
								onChange={e => setFiltroTipoPedido(e.target.value)}>
								<option value="Todos">Filtro Tipo</option>
								<option value="App">App</option>
								<option value="Facturación">Tienda Física</option>
								<option value="Tienda">Página web</option>
								<option value="Activacion">Activaciones</option>
							</select>
						</div>

					</div>


					<TableroInforme resultados={resultados} animado={false} load={load} />

					<ReactToPrint
						pageStyle={`{margin:2px }`}
						trigger={() => {
							// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
							// to the root node of the returned component as it will be overwritten.
							return <a className='btn boton_estandar mx-0'>Imprimir Informe</a>;
						}}
						content={() => ventasImprimir.current}
					/>


					<div ref={ventasImprimir}>
						<h4><br />Ventas por medio de Pago:</h4>
						<VentasDiscriminadas data={mediosdePagoRecarFull} />

						<h4><br />Ventas por Usuario:</h4>
						<VentasDiscriminadas data={usuariosFull} />


						<h4><br />Ventas por Productos:</h4>
						<VentasDiscriminadas data={productoFull} />


						<h4><br />Descuentos Personalizados:</h4>
						<VentasDiscriminadas data={descPersoFull} />
					</div>



				</div>


				: null}
			{funcion === 'cierreX' ?
				<div className="">
					<hr />
					<center>
						<p>¿Está seguro que quiere cerra la caja X?</p>
						<button
							onClick={e => setFuncion('ver')}
							className="btn boton_estandar">
							Salir
						</button>
						{btnsCierre ?
							<div>
								<button
									onClick={CierreDefinitivo('X', 'completo')}
									className="btn boton_estandar">
									Realizar cierre X Completo
								</button>
								<button
									onClick={CierreDefinitivo('X', 'parcial')}
									className="btn boton_estandar">
									Realizar cierre X Parcial
								</button>
							</div>
							: null}
						{resultCierre ?
							<ImpresionCierre cierre={cierre} consecutivo={consecutivo} />
							: null}
					</center>
				</div>
				: null}
			{funcion === 'cierreZ' ?
				<div className="">
					<hr />
					<center>
						<p>¿Está seguro que quiere cerra la caja?</p>
						<button
							onClick={e => setFuncion('ver')}
							className="btn boton_estandar">
							Salir
						</button>
						{btnsCierre ?
							<button
								onClick={CierreDefinitivo('Z', 'completo')}
								className="btn boton_estandar">
								Realizar cierre
							</button>
							: null}
						{resultCierre ?
							<ImpresionCierre cierre={cierre} consecutivo={consecutivo} />
							: null}

					</center>
				</div>
				: null}




		</div>
	)
}

export default InformesAdmin

